var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirwallex = function SvgAirwallex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 186 127"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 182.562,
    height: 124.354,
    x: 1.323,
    y: 1.323,
    fill: "#fff",
    stroke: "#D9D9D9",
    strokeWidth: 2.646,
    rx: 14.552
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#airwallex_svg__a)",
    d: "M139.255 57.204a12.39 12.39 0 0 1 2.938 13.267l-6.527 17.733c-1.714 4.656-5.618 8.258-10.443 9.198a13.57 13.57 0 0 1-13.157-4.7L72.93 45.804a.862.862 0 0 0-1.468.259L58.73 80.508c-.264.712.437 1.403 1.132 1.118l15.625-6.382a6.9 6.9 0 0 1 9.165 4.3c1.154 3.54-.786 7.364-4.204 8.76l-20.411 8.335c-3.778 1.545-8.12 1.272-11.523-1a12.41 12.41 0 0 1-4.74-14.63l15.045-40.684c1.782-4.822 5.842-8.227 10.86-9.106a13.97 13.97 0 0 1 13.26 4.882L105.4 63.023l20.661-8.441c4.591-1.875 9.647-.871 13.193 2.622m-11.917 13.522c.262-.71-.439-1.4-1.133-1.114l-11.417 4.66 6.845 8.209a.864.864 0 0 0 1.477-.26z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "airwallex_svg__a",
    x1: 43,
    x2: 6195.92,
    y1: 29.8,
    y2: 9262.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8E3C"
  })))));
};
export default SvgAirwallex;